import { gsap } from "../gsap.js";

export default function initBackToTop() {
  const scrollToButtons = document.querySelectorAll(".scroll-to");
  const backToTopButton = document.querySelector(".back-to-top");

  if (!scrollToButtons.length && !backToTopButton) return;

  // Setup back-to-top button visibility logic if exists
  if (backToTopButton) {
    // Set initial state
    gsap.set(backToTopButton, {
      opacity: 0,
      visibility: "hidden",
    });

    let isVisible = false;

    // Function to show button
    const showButton = () => {
      if (!isVisible) {
        isVisible = true;
        backToTopButton.classList.add("show");
        gsap.to(backToTopButton, {
          opacity: 1,
          visibility: "visible",
          duration: 0.3,
          ease: "power2.out",
        });
      }
    };

    // Function to hide button
    const hideButton = () => {
      if (isVisible) {
        isVisible = false;
        backToTopButton.classList.remove("show");
        gsap.to(backToTopButton, {
          opacity: 0,
          visibility: "hidden",
          duration: 0.3,
          ease: "power2.in",
        });
      }
    };

    // Handle scroll
    let ticking = false;
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const quarterPage = pageHeight / 4;

      if (scrollY > quarterPage) {
        showButton();
      } else {
        hideButton();
      }
    };

    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Initial check
    handleScroll();
  }

  // Click handlers for all scroll-to elements
  if (!scrollToButtons.length) return;
  scrollToButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
}
